export const wordFormation = [
  {
    id: 'praefixe-untr',
    category: 'wortbildung',
    level: 'B1',
    title: 'Präfixe thelbësore t pandashme (be-, ver-, ent-, er-, zer-)',
    detailedContent: `
      <section>
        <p>Parashtesa ashtu edhe vet termet tregojnt THELlE që jan pjes të qepur thelbt Foljes. Ndryshojn thelbësishisht kuptimsn e saj!</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli Praktikt Kyc Thel:</strong> Kur folja vesh këtThes prapShtesa: AJO NUK NDASHEN THELB NE FJALI - dhe ne Partizip II AJO <b>NUK MERR KURT t(ge-)</b> ne fillm! (Verstehen - Ich habe <b>verstanden</b> / Jo: ge-verstanden).
        </div>

        <h3>ParaThelstes Kryesorja:</h3>
        <ul>
          <li><b>be-</b>: Bën një folje Intransitivetht - Transitve. (Wohnen (loj) -> <b>be</b>wohnen (banoj një T sakt thell shtpi)).</li>
          <li><b>ver-</b>: Thelb i kaluesits / kalim kohes / apo nji GABTHELM (Sich <b>ver</b>laufen = hmubas rruge Thells)</li>
          <li><b>ent-</b>: heqtni / dhemnthe (<b>ent</b>koffeinfert = heqja thell t kaftent).</li>
          <li><b>er-</b>: arrithmthe jep resultajsi.. <b>er</b>finden = zbumo thelb...</li>
          <li><b>zer-</b>: thelbe Theth thytse Thell / coputash Thell= <b>zer</b>stören (shkkateroi  Kthelb thethshshd ). </li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'suffixe-nomen',
    category: 'wortbildung',
    level: 'B1',
    title: 'Prapashtesa Suffixe (-heit, -keit, -ung, -schaft)',
    detailedContent: `
      <section>
        <p>Formimi tEmrava! Kthejn Folj e mbitmat njiEmresh! Kur t shohqisni kto prapsths, dini me sy me mbyllthsi QË EMRIA ËSHTË thelbsithe FEMIthellN (die)! </p>

        <ul>
          <li><b>-ung:</b> 90% delthelb prej Foljave. (entscheiden -> die Entscheid<b>ung</b> - vendosnja).</li>
          <li><b>-heit / -keit:</b> DelThti prej Mbiemarave (schön -> die Schön<b>heit</b> - thBukuresja. / möglich -> die Möglich<b>keit</b> - mUdjesihsht Thelbet)</li>
          <li><b>-schaft:</b>  Die Freund<b>schaft</b> (mqësiseit Thelb)</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  }
];
